export default "__VITE_ASSET__C2mlx60U__"